import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { BreadcrumbModule } from "libraries/component/breadcrumb/breadcrumb.module";
import { QuotationBreadcrumbComponent } from "./quotation-breadcrumb.component";
import { QuotationBreadcrumbService } from "./quotation-breadcrumb.service";
import { BtnModule } from "libraries/ui_button/btn.module";

@NgModule({
    imports: [
        CommonModule,
        BreadcrumbModule,
        BtnModule,
    ],
    exports: [
        QuotationBreadcrumbComponent
    ],
    declarations: [
        QuotationBreadcrumbComponent
    ],
    providers: [
        QuotationBreadcrumbService
    ],
})
export class QuotationBreadcrumbModule {
}
